import { createBrowserRouter, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

// Pages
import LoginPage from '../pages/auth/LoginPage';
import PanelLayout from '../pages/panel/PanelLayout';
import HomePage from '../pages/panel/HomePage';
import DashboardPage from '../pages/panel/DashboardPage';
import GanttViewerPage from '../pages/panel/GanttViewerPage';

// Admin Pages
import AdminLayout from '../pages/admin/AdminLayout';
import UsersPage from '../pages/admin/UsersPage';
import CategoriesPage from '../pages/admin/CategoriesPage';
import SubcategoriesPage from '../pages/admin/SubcategoriesPage';
import UserHistoryPage from '../pages/admin/UserHistoryPage';
import GlobalHistoryPage from '../pages/admin/GlobalHistoryPage';
import SubcategoryHistoryPage from '../pages/admin/SubcategoryHistoryPage';
import GanttAdminPage from '../pages/admin/GanttAdminPage';

import DocsListPage from '../pages/docs/DocsListPage';
import DocEditorPage from '../pages/docs/DocEditorPage';
import DocViewPage from '../pages/docs/DocViewPage';
import DocHistoryPage from '../pages/docs/DocHistoryPage';
import OrganizationsPage from '../pages/admin/OrganizationsPage';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Navigate to="/login" replace />,
    },
    {
        path: '/login',
        element: <LoginPage />,
    },
    {
        path: '/panel',
        element: (
            <ProtectedRoute>
                <PanelLayout />
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <HomePage />,
            },
            {
                path: 'dashboard/:id',
                element: <DashboardPage />,
            },
            {
                path: 'docs',
                children: [
                    { index: true, element: <DocsListPage /> },
                    { path: 'new', element: <DocEditorPage /> },
                    { path: ':id', element: <DocViewPage /> },
                    { path: ':id/edit', element: <DocEditorPage /> },
                    { path: ':id/history', element: <DocHistoryPage /> },
                ],
            },
        ],
    },
    {
        path: '/admin',
        element: (
            <ProtectedRoute adminOnly>
                <AdminLayout />
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <Navigate to="users" replace />,
            },
            {
                path: 'users',
                element: <UsersPage />,
            },
            {
                path: 'users/:userId/history',
                element: <UserHistoryPage />,
            },
            {
                path: 'categories',
                element: <CategoriesPage />,
            },
            {
                path: 'subcategories',
                element: <SubcategoriesPage />,
            },
            {
                path: 'subcategories/:subId/history',
                element: <SubcategoryHistoryPage />,
            },
            {
                path: 'history',
                element: <GlobalHistoryPage />,
            },
            {
                path: 'organizations',
                element: <OrganizationsPage />,
            },
            {
                path: 'gantt',
                element: <GanttAdminPage />,
            },
            {
                path: 'docs',
                children: [
                    { index: true, element: <DocsListPage /> },
                    { path: 'new', element: <DocEditorPage /> },
                    { path: ':id', element: <DocViewPage /> },
                    { path: ':id/edit', element: <DocEditorPage /> },
                    { path: ':id/history', element: <DocHistoryPage /> },
                ]
            },
        ],
    },
    {
        path: '*',
        element: <Navigate to="/login" replace />,
    },
]);

export default router;
